class RestAPIQuery {

    public URLArgs: any = new URLSearchParams();
    public RestAPIBase: string = '/wp-json/moman/v1/search';
    public params: any = null;
    public container: any = null;
    public resultsContainer: any = null;
    public form: any = null;
    public pagerContainer: any = null;
    public countResultsContainer: any = null;
    public containerSubCategory: any = null;
    public resultsContainerCategoryChildren: any = null;
    public customSelectCategoryChildren: any = null;
    public noResultsContainer: any = null;
    public suggestContainer: any = null;
    public titles: any = null;
    public dateRangePicker: any = null;
    public formFilters: Array<string> = [];

    constructor(params: any) {
        this.params = params;

        if (params.container) {
            this.container = params.container;
        }
        else {//fallback sur tout le document si on a un oubli de container
            this.container = document;
        }

        this.resultsContainer = this.container.querySelector('[data-results]');
        if (!this.resultsContainer) {
            console.error('Il te manque un bloc résultats avec data-results !');
        }
        this.pagerContainer = this.container.querySelector('[data-pager]');
        if (!this.pagerContainer && this.params.searchType != "trombinoscope") {
            console.error('Il te manque un pagination avec data-pager !');
        }
        this.countResultsContainer = this.container.querySelector('[data-count-results]');
        if (!this.countResultsContainer) {
            console.error('Il te manque une nombre de résultats avec data-count-results !');
        }
        this.noResultsContainer = this.container.querySelector('[data-no-results]');
        if (!this.noResultsContainer) {
            console.error('Il te manque un bloc pas de résultats avec data-no-results !');
        }
        this.suggestContainer = this.container.querySelector('[data-suggest]');
        this.titles = document.querySelectorAll('[data-dynamic-title]');

        this.form = this.container.querySelector('[data-form]');
        if (!this.form) {
            console.error('Il te manque un formulaire avec data-form !');
        }

        this.containerSubCategory = this.container.querySelector('[data-sub-categories]');
        this.resultsContainerCategoryChildren = this.container.querySelector('[data-categoryChildren]');
        this.customSelectCategoryChildren = this.container.querySelector('[data-period-dropdown]')

        //Ajoutez ici les autres filtres de votre liste si ils ne sont pas pris en compte
        this.formFilters = ['data-keywords', 'data-date-range', 'data-start-date', 'data-end-date', 'data-categorychildren', 'data-period', 'data-post-type', 'data-sort', 'data-commission','data-year', 'data-filiere', 'data-type-emploi', 'data-categorie-emploi'];
        this.initUrlArgs();
        this.addEventListeners();
    }

    initUrlArgs(noCategoryUrl = false) {
        if (this.params.searchType) {
            this.URLArgs.set('searchType', this.params.searchType);
        }
        else {
            console.error('SearchType non défini !!');
        }
        // @ts-ignore
        if (window['moman_query'] && window['moman_query']['post_id']) {//on Ajoute l'id de la page en cours
            // @ts-ignore
            this.URLArgs.set('postId', window['moman_query']['post_id']);
        }
        const params = new Proxy(new URLSearchParams(window.location.search), {
            // @ts-ignore
            get: (searchParams, prop) => searchParams.get(prop),
        });

        // @ts-ignore
        if (!noCategoryUrl && params.category !== null) {
            // @ts-ignore
            this.URLArgs.set('category', params.category);
        }
    }

    removeActiveCategory() {
        const currentCategorySelected = this.container.getElementsByClassName('active-category');
        if (currentCategorySelected.length) {
            currentCategorySelected[0].classList.remove('active-category');
        }
    }

    addEventListeners() {
        //CATEGORIES
        const $categoryButton = this.container.querySelectorAll('[data-category-filter]');
        if ($categoryButton.length) {
            for (let i = 0; i < $categoryButton.length; i++) {
                $categoryButton.item(i).addEventListener('click', (e: any) => {
                    e.preventDefault();
                    this.removeActiveCategory();
                    $categoryButton.item(i).classList.add('active-category');
                    const $catID = $categoryButton.item(i).getAttribute('data-category-filter');
                    if ($catID) {
                        if ($catID == 'all') {//si on clique sur tout alors plus de filtre.
                            this.URLArgs.delete('category');
                        } else {
                            this.URLArgs.set("category", $catID);
                        }
                        this.URLArgs.delete('categoryChildren');
                        this.executeAjaxSearch();
                    }
                });
            }
        }


        //Soumission de formulaire
        this.form.addEventListener("submit", (e: any) => {
            e.preventDefault();
            this.buildFormDatas();
            this.executeAjaxSearch();
        });

        //Bouton réinitialiser
        const $resetButton = this.form.querySelector('[data-reset]');
        if ($resetButton) {
            $resetButton.addEventListener('click', (e: any) => {
                this.URLArgs = new URLSearchParams();//ça reset tous les params coté class
                this.initUrlArgs(true);//on remet le searchType et PostID de base, on ne prend pas la catégorie dans l'url (argument true)
                this.removeActiveCategory();//retrait de la catégorie courante
                this.formFilters.forEach((formFilter) => { //retrait des valeurs de tous les autres filtres
                    const $selector = this.container.querySelector('[' + formFilter + ']');
                    if ($selector) {
                        $selector.value = '';
                    }
                });
                // On reset les custom selects
                const customPeriod = document.querySelectorAll('[data-custom-select]') || null;
                if (customPeriod) {
                    customPeriod.forEach(item => {
                        const getSelect = item.querySelector('[data-custom-select] select') as HTMLSelectElement;
                        const getLabel = getSelect.getAttribute('aria-label');
                        item.querySelector('.dropdown-first').innerHTML = getLabel;
                        if(item.querySelector('.dropdown-first').classList.contains('selected')) {
                            item.querySelector('.dropdown-first').classList.remove('selected');
                        }
                    });
                }
                if (this.containerSubCategory) {
                    this.containerSubCategory.classList.add('hidden');
                }
                if (this.params.searchType === "mainSearch") {
                    this.URLArgs.set('s', '');
                }

                this.executeAjaxSearch();//on relance l'ajax


            });
        }

        //DateRangePicker
        const periodCustom = this.container.querySelector('[data-period-custom]');

        if (periodCustom) {
            //Options du dateRangePicker: https://mymth.github.io/vanillajs-datepicker/#/options
            // @ts-ignore
            this.dateRangePicker = new DateRangePicker(periodCustom, {
                // @ts-ignore
                language: window['moman_global']['short_locale'] ?? 'fr'
            });
        }

        //Period
        this.form.addEventListener('input', (e: any) => {

            //Pour tester rapidement:
            //console.log( e.target.getAttribute('data-arg-name') , e.target.value );

            if (
                e.target.getAttribute('data-arg-name') !== 'period'
                && e.target.getAttribute('data-arg-name') !== 'sort'
            )
                return;

            if (e.target.getAttribute('data-arg-name') === 'period') {
                if (e.target.value === 'custom') {
                    if (periodCustom) {
                        periodCustom.classList.remove('hidden');
                    }
                } else {
                    if (periodCustom) {
                        periodCustom.classList.add('hidden');
                    }
                }
            }
            else if (e.target.getAttribute('data-arg-name') === 'sort') {
                this.buildFormDatas();
                this.executeAjaxSearch();
            }


        }, false);


        //Pagination
        const $pager = this.container.querySelector('[data-pager]') || null;
        if (this.params.searchType !== "trombinoscope") {
            $pager.addEventListener('click', (e: any) => {
                if (e.target.getAttribute('data-page-number')) {
                    e.preventDefault();
                    this.buildFormDatas();
                    this.URLArgs.set('paged', e.target.getAttribute('data-page-number'));
                    this.executeAjaxSearch(false);
                }
            });
        }

    }

    buildFormDatas() {
        //Liste des champs dont on veut récupérer les valeurs
        this.formFilters.forEach((formFilter) => {
            const $selector = this.container.querySelector('[' + formFilter + ']');
            if ($selector) {
                const argName = $selector.getAttribute('data-arg-name');
                if (argName) {
                    this.URLArgs.set(argName, $selector.value);
                }
                else {
                    console.error('attribut data arg name non renseigné !');
                }
            }
        });
    }

    async fetch() {
        // @ts-ignore
        const url = window['moman_global']['base_url'] + this.RestAPIBase + '?' + this.URLArgs.toString();
        this.resultsContainer.insertAdjacentHTML('beforebegin', `<div class="filter-loader"><span></span></div>`);
        this.countResultsContainer.classList.add('loading');
        this.resultsContainer.classList.add('loading');
        let response = await fetch(url, {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
        })
        return await response.json()
    }

    executeAjaxSearch(resetPager = true) {

        if (resetPager && this.params.searchType == ! "trombinoscope") {
            this.URLArgs.set('paged', 1);
        }
        this.fetch().then((data: any) => {
            document.querySelector('.filter-loader') ? document.querySelector('.filter-loader').remove() : ''
            this.countResultsContainer.classList.remove('loading');
            this.resultsContainer.classList.remove('loading');
            console.log("fetch ok !", data);
            if (data.moman_is_ok === true) {
                if (this.params.searchType === "trombinoscope") {
                    // @ts-ignore

                    generateTrombi(data.trombi);
                } else {
                    console.log("mise à jour de la liste de résultat");
                    this.resultsContainer.innerHTML = data.list;
                    if (this.pagerContainer) {//Pagination
                        console.log("mise à jour de la pagination");
                        this.pagerContainer.innerHTML = data.pager;
                    }
                    if (this.countResultsContainer.innerHTML && data.count_title) {//Nombre de résultats
                        console.log("mise à jour du compteur de résultats");
                        if (data.count === 0) {
                            this.countResultsContainer.classList.add("hidden");
                        }
                        else {
                            this.countResultsContainer.classList.remove("hidden");
                            this.countResultsContainer.innerHTML = data.count_title;
                        }
                    }
                    if (this.noResultsContainer) {//on masque la zone pas de résultat
                        this.noResultsContainer.classList.add("hidden");
                    }

                    if (this.suggestContainer) {//on masque la zone de suggestion
                        if (data.suggest !== '' && data.suggest != null) {
                            this.suggestContainer.classList.remove("hidden");
                            this.suggestContainer.innerHTML = data.suggest;
                        } else {
                            this.suggestContainer.classList.add("hidden");
                        }
                    }

                    if (data.count === 0 && this.noResultsContainer) {
                        this.noResultsContainer.classList.remove("hidden");
                    }

                    if (this.containerSubCategory && this.resultsContainerCategoryChildren) {
                        if (data.cat_children) {
                            console.log("mise à jour du container des sous categories");
                            this.containerSubCategory.classList.remove("hidden");
                            this.resultsContainerCategoryChildren.innerHTML = data.cat_children;
                            //@ts-ignore
                            customSelectNav();
                        } else {
                            console.log("mise à jour du container des sous categories");
                            this.containerSubCategory.classList.add("hidden");
                            this.resultsContainerCategoryChildren.innerHTML = "";
                        }
                    }
                }


                if (this.params.searchType === "mainSearch" && this.titles.length > 0 && data.title !== '') {//pour le moteur de recherche on mets à jour le titre de la page.
                    for (let i = 0; i < this.titles.length; i++) {
                        this.titles.item(i).innerHTML = data.title;
                    }
                }
                history.pushState(null, null, "?" + data.url_query);
                this.executeCallbackAjax();
            }
            else {
                console.error('Erreur !', data);
                alert('Une erreur est survenue lors de votre recherche');
            }

        }).catch(error => {
            console.error('Erreur !', error);
        });
    }

    executeCallbackAjax() {
        //Callback pour recréer les listeners sur le custom select
        if (this.params.ajaxCallback) {
            console.log("Callback après ajax lancé !");
            this.params.ajaxCallback();
        }
    }

}
